module.exports = __webpack_public_path__ + "static/media/Pngfooter3.8c7935d6.png";